import script from "./NavHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavHeader.vue?vue&type=script&setup=true&lang=ts"

import "./NavHeader.vue?vue&type=style&index=0&id=46579952&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46579952"]])

export default __exports__